import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService, LanguageService  } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'app-edit-sub-menu-header-admin',
  templateUrl: './edit-sub-menu-header-admin.component.html',
  styleUrls: ['./edit-sub-menu-header-admin.component.scss']
})
export class EditSubMenuHeaderAdminComponent implements OnInit {
  @Input() data: any; // dữ liệu menu từ component cha truyền vào
  @Input() isAutoTranslate;
  @Output() isCancelFormEditSub = new EventEmitter(); // phát tính hiệu cancel cho component cha
  @Output() valueDataEdit = new EventEmitter(); // phát tính hiệu khi lưu cho component cha

  // Mảng danh sách type (none/link-page/website/link-url/category)
  listLink = [
    {
      url: 'none',
      name: 'khong'
    },
    {
      url: 'link-page',
      name: 'den_trang_trong_website'
    },
    {
      url: 'website',
      name: 'lien_ket_website_khac'
    }
  ];

  isValid: boolean = true; // Biến này xác định form đã valid hay chưa (true: valid; false: chưa)
  listCategory = []; // biến này lấy dữ liệu các danh mục
  // listCateSelected = new FormControl([]); // biến này chứa các danh mục được add
  initCategories = [];

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    public functionService: FunctionService,
    private languageService: LanguageService,
  ) {
  }

  ngOnInit(): void {
    // Lấy dữ liệu
    this.getCategorySteps();
    // Kiểm tra lần đầu để disabled nút lưu hay không
    this.onChangeAttr();
  }


  // Lấy danh sách category
  getCategorySteps() {
    this.vhQueryAutoWeb.getCategorySteps_byIdFatherCategory("", {}, {})
      .then((response: any) => {
        if (response.vcode === 0) {
          this.listCategory = this.initCategories = response.data;
          this.listCategory = this.listCategory.filter((subCate) => {
            return !this.data.item?.subData?.some((cates) => {
              return cates.listCateSelected?.some((cate) => subCate._id === cate);
            });
          });
        }
      }, (error: any) => {
        
      })
  }

  

  

  /**
   * Bắt sự kiện thay đổi các trường trong from
   */
  onChangeAttr() {
    const menu = this.data.childMenu;

    setTimeout(() => {
      if (!menu) return;

      const isValidBody =
          (menu.type === 'none') ||
          (menu.type === 'link-page') ||
          (menu.type === 'website' && menu.link_website) 
      const checkLangMissingShort = this.functionService.multi_languages.some(lang => !menu[`name_${lang.code}`]?.trim());

      this.isValid = !checkLangMissingShort && (isValidBody);
    }, 50)
  }

  /**
   * Lưu giá trị form chỉnh sửa menu con và truyền về đi giao diện hiển thị
   */
  saveValueDataEdit() {
    // Xóa các trường không cần
    const menu = this.data.childMenu;
    // Xóa theo type
    const typeFieldsToDeleteMap = {
      'none': ['link_page', 'link_website'],
      'link-page': ['link_website' ],
      'website': ['link_page', 'click_action', 'scroll_block_id'], 
    };
    // Xóa theo group
    const groupFieldsToDeleteMap = {
      'link': ['id_page_category', 'id_freeblock'],
      'category': ['id_freeblock'],
      'pop-up': ['id_page_category']
    };
    // Mảng chứa các trường cần xóa
    const fieldsToDelete = typeFieldsToDeleteMap[menu.type] || [];
    fieldsToDelete.push(...groupFieldsToDeleteMap[menu.group] || []);
    // Xóa
    this.deleteFields(menu, fieldsToDelete);

    if (this.data.childMenu.type === 'link-page' && this.data.childMenu.link_page === undefined) this.data.childMenu.link_page = '';
    let link = this.data.childMenu.link_page;
    link = link ? '/' + link.replace(/^\/+/, '').replace(/\/+$/, '') : '';
    this.data.childMenu.link_page = link === '/' ? '' : link;


    this.valueDataEdit.emit(this.data);
    this.isCancelFormEditSub.emit(false);
  }

  /**
   * Xóa các trường trong object
   * @param {Object} data - Object có trường cần xóa
   * @param {Array} fieldsToDelete - Mảng chứa tên các trường cần xóa
   */
  deleteFields(data, fieldsToDelete) {
    fieldsToDelete.forEach(field => {
      delete data[field];
    });
  }

  /**
   * Đóng form sửa menu con
   */
  cancelFormEditSub() {
    this.isCancelFormEditSub.emit(false);
  }
  
  autoTranslateNameLang() {    
    if (this.isAutoTranslate && this.data.childMenu['name_' + this.functionService.languageTempCode]) {
      this.functionService.showLoading(
        this.languageService.translate('dang_dich_cac_ngon_ngu_con_lai_cho_ten_menu_con'),
        "current-loading", null, 0, false
      ).then(() => {
        this.functionService.translateToMultipleLanguages(
          this.data.childMenu['name_' + this.functionService.languageTempCode],
          { isAdmin: true }
        )
        .subscribe({
          next: (data) => {
            // console.log('data', data)
            this.functionService.multi_languages.forEach(lang => {
              if (this.functionService.languageTempCode != lang.code) {
                this.data.childMenu['name_' + lang.code] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            });
            this.onChangeAttr(); // Cập nhật lại để nút "Thêm" hủy disabled
            this.functionService.hideLoading(300);
          },
          error: (err) => {
            console.error('Lỗi dịch thuật:', err);
            this.functionService.hideLoading(300);
          }
        });
      });
    }
  }
}
